import React, {useEffect} from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useLocation,
} from 'react-router-dom';
import { Navbar, Sidebar, Toast, ErrorBoundary } from './components';
import 'react-toastify/dist/ReactToastify.css';
import Footer from './components/Footer';
import './App.css';
import {
  Home,
  About,
  Cart,
  SingleProduct,
  Checkout,
  Error,
  Login,
  Register,
  Forgot,
  ResetPasswordPage,
  OrdersPage,
  PrivateRoute,
  ProfilePage,
  StoreLocation,
  WishlistPage,
  UpdatePasswordPage,
  ProductPage,
} from './pages';
import ContactUsPage from './pages/ContactUsPage';
import TermsAndConditions from './pages/TermsAndConditions/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import ComplimentaryShipping from './pages/ComplimentaryShipping/ComplimentaryShipping';
import StoreLocationPage from './pages/StoreLocationPage';

const GAListener=()=> {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname,
      });
    }
  }, [location]);

  return null;
}

function App() {
  return (
    <Router>
      <GAListener />
      <AppContent />
    </Router>
  );
}

const AppContent = () => {
  const location = useLocation();

  return (
    <div style={{ maxHeight: '100vh' }}>
      <Toast />
      <Navbar />
      <Sidebar />
      <ErrorBoundary>
        <Switch>
          <Route exact path='/'>
            <Home />
          </Route>
          <Route exact path='/home'>
            <Home />
          </Route>
          <Route exact path='/about'>
            <About />
          </Route>
          <Route exact path='/contact'>
            <ContactUsPage />
          </Route>
          <Route exact path='/termsAndConditions'>
            <TermsAndConditions />
          </Route>
          <Route exact path='/privacyPolicy'>
            <PrivacyPolicy />
          </Route>
          <Route exact path='/collections'>
            <ProductPage />
          </Route>
          <Route exact path='/store-location'>
            <StoreLocation />
          </Route>
          <Route exact path='/cart'>
            <Cart />
          </Route>
          <Route exact path='/wishlist'>
            <WishlistPage />
          </Route>
          <Route exact path='/stores'>
            <StoreLocationPage />
          </Route>
          <Route exact path='/complimentaryShipping'>
            <ComplimentaryShipping />
          </Route>
          <PrivateRoute exact path='/login'>
            <Login />
          </PrivateRoute>
          <PrivateRoute exact path='/register'>
            <Register />
          </PrivateRoute>
          <PrivateRoute exact path='/forgot-password'>
            <Forgot />
          </PrivateRoute>
          <PrivateRoute exact path='/reset-password'>
            <ResetPasswordPage />
          </PrivateRoute>
          <Route exact path='/collections/:id' children={<SingleProduct />} />
          <PrivateRoute exact path='/checkout'>
            <Checkout />
          </PrivateRoute>
          <PrivateRoute exact path='/orders'>
            <OrdersPage />
          </PrivateRoute>
          <PrivateRoute exact path='/profile'>
            <ProfilePage />
          </PrivateRoute>
          <PrivateRoute exact path='/update-password'>
            <UpdatePasswordPage />
          </PrivateRoute>
          <Route exact path='*'>
            <Error />
          </Route>
        </Switch>
      </ErrorBoundary>
      <Footer />
    </div>
  );
};

export default App;
